module.exports = __webpack_public_path__ + "static/media/Эгамов А.И., Бураго П.Н. (ММ).4fd83813.pdf";